import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'widget__fold',
  props: {
    maxHeight: Number,
    unfoldText: {
      type: String,
      default: '收起更多'
    },
    blur: {
      type: Boolean,
      default: false
    },
    foldedText: {
      type: String,
      default: '展开更多'
    }
  },
  data: function data() {
    return {
      isFolded: true,
      hasFold: false
    };
  },
  mounted: function mounted() {
    this.checkFold();
  },
  methods: {
    checkFold: function checkFold() {
      if (this.$refs.content.offsetHeight <= this.maxHeight) {
        this.hasFold = false;
        this.isFolded = false;
      } else {
        this.hasFold = true;
        this.isFolded = true;
      }
    },
    onFoldBtnClick: function onFoldBtnClick() {
      this.isFolded = !this.isFolded;
    }
  }
};